import { isEmpty } from '@sgme/fp';
import { ProductVariationBase } from 'models/productsReferential';
import {
  getAllOrdersBasketFormIdsByProductSubType,
  getOrdersBasketFieldsMetadata,
} from 'state/orders-basket/selectors';
import type { ProductGraph } from 'state/product-description/model';
import {
  getBatchFormMustForceAdvancedMode,
  getUserPreferencesBatchWorkspaceVersion,
  sanitizeProductDescription,
} from 'state/selectors';
import type { AppState } from 'state/state.model';

export function selectOrdersBasketWorkspaceProductDefinitionsState(state: AppState) {
  const productDefinitionsState = state.productDescription.products['OrdersBasket'];
  return productDefinitionsState;
}

export function getOrdersBasketProductDefinitionsByProductVariation(
  appState: AppState,
  product: ProductVariationBase,
): ProductGraph | undefined {
  const state = selectOrdersBasketWorkspaceProductDefinitionsState(appState);
  return state?.[product.productType]?.[product.productSubType];
}

const emptyArray: readonly [] = [];
export function getOrdersBasketFieldIdsByProductVariation(
  appState: AppState,
  product: ProductVariationBase,
): readonly string[] {
  const productDefinitions = getOrdersBasketProductDefinitionsByProductVariation(appState, product);
  return productDefinitions === undefined
    ? emptyArray
    : productDefinitions.reduce<string[]>((acc, currentBlock) => {
        currentBlock.children?.forEach(i => {
          acc.push(i.id);
        });
        return acc;
      }, []);
}

export function getOrdersBasketNumberOfFieldsByProductDescription(
  appState: AppState,
  product: ProductVariationBase,
): number {
  const fieldIds = getOrdersBasketFieldIdsByProductVariation(appState, product);
  return fieldIds.length;
}

export function getVisibleOrdersBasketProductDefinitionsByProductVariation(
  appState: AppState,
  product: ProductVariationBase,
): ProductGraph | undefined {
  const productDefinitions = getOrdersBasketProductDefinitionsByProductVariation(appState, product);
  const allFormIds = getAllOrdersBasketFormIdsByProductSubType(appState, product);
  const allFieldsMetaData = allFormIds.map(formId => getOrdersBasketFieldsMetadata(appState, formId));
  const batchWorkspaceVersion = getUserPreferencesBatchWorkspaceVersion(appState);
  const mustForceAdvancedMode = getBatchFormMustForceAdvancedMode(appState, allFormIds);
  const sanitizedProductDescription =
    productDefinitions === undefined
      ? undefined
      : sanitizeProductDescription(productDefinitions, allFieldsMetaData, batchWorkspaceVersion, mustForceAdvancedMode);

  return isEmpty(sanitizedProductDescription) ? productDefinitions : sanitizedProductDescription;
}
